var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"fluid":""}},[_c('b-modal',{attrs:{"id":"deleteNews","title":"DELETE NEW"},on:{"ok":_vm.DeleteNews}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._v("Do you want to delete this New ?")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8e34436","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/News/NewsDelete.vue
// module id = /FOX
// module chunks = 1